import { navigateToSection } from '../../utils/helpers';
import { useNavigate, useLocation } from 'react-router-dom';

import { IconCheck, IconArrowBigRightLines } from '@tabler/icons-react';

const About = () => {
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <div className="container-fluid about testimonial py-5" id="about">
            <div className="container py-5">
                <div className="row g-5 mt-1">
                    
                    <div className="col-lg-6" style={{ minHeight: '400px' }}>
                        <div className="position-relative h-100" data-aos="fade-down" data-aos-offset="-80" data-aos-delay="400">
                            <img className="position-absolute img-fluid w-100 h-100" src="images/auto-parts-2.webp" style={{ objectFit: 'cover' }} alt="Despre noi - Piese Auto"/>
                            <div className="position-absolute top-0 end-0 mt-n4 me-n4 py-4 px-5 d-flex align-items-center justify-content-center" style={{ width: '110px', height: '110px', borderRadius: '50%', transform: 'rotate(15deg)' }}>
                                <img src="images/logo.webp" alt="Logo" style={{ maxWidth: '90px', filter: 'drop-shadow(2px 2px 5px rgba(0, 0, 0, 0.3))' }} />
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-6">
                        <h6 className="heading text-danger text-uppercase" data-aos="fade-up" data-aos-offset="-80" data-aos-delay="400">Despre Noi</h6>
                        <h1 className="heading mb-4" data-aos="fade-up" data-aos-offset="-80" data-aos-delay="400">
                            <span className="text-danger">MISU LZR MobAuto</span> - Piese Auto de Incredere, Direct de la Furnizori
                        </h1>

                        <p className="info mb-4" data-aos="fade-up" data-aos-offset="-80" data-aos-delay="400"> Gasirea pieselor potrivite pentru masina ta poate fi complicata, dar nu cu noi! Oferim piese originale si aftermarket la cele mai bune preturi, direct de la furnizori. In plus, te ajutam gratuit cu verificarea compatibilitatii pieselor folosind seria de sasiu. </p>
                        
                        <div className="row g-4 mb-3 pb-3">
                            
                            <div className="col-12" data-aos="fade-up" data-aos-offset="-80" data-aos-delay="600">
                                <div className="d-flex">
                                    <div className="bg-light d-flex flex-shrink-0 align-items-center justify-content-center mt-1" style={{ width: '45px', height: '45px' }}>
                                        <IconCheck stroke={1.8} size={26} />
                                    </div>
                                    <div className="ps-3">
                                        <h6 className="heading">Piese Auto la Preturi Competitive</h6>
                                        <span className="info"> Colaboram direct cu furnizorii pentru a-ti oferi cele mai mici preturi, fara costuri ascunse. </span>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12" data-aos="fade-up" data-aos-offset="-80" data-aos-delay="700">
                                <div className="d-flex">
                                    <div className="bg-light d-flex flex-shrink-0 align-items-center justify-content-center mt-1" style={{ width: '45px', height: '45px' }}>
                                        <IconCheck stroke={1.8} size={26} />
                                    </div>
                                    <div className="ps-3">
                                        <h6 className="heading">Verificare Gratuita a Compatibilitatii</h6>
                                        <span className="info"> Iti verificam gratuit piesele folosind seria de sasiu, evitand achizitiile gresite. </span>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12" data-aos="fade-up" data-aos-offset="-80" data-aos-delay="1000">
                                <div className="d-flex">
                                    <div className="bg-light d-flex flex-shrink-0 align-items-center justify-content-center mt-1" style={{ width: '45px', height: '45px' }}>
                                        <IconCheck stroke={1.8} size={26} />
                                    </div>
                                    <div className="ps-3">
                                        <h6 className="heading">Economiseste Timp si Bani</h6>
                                        <span className="info"> Nu mai pierde timp cautand cele mai bune preturi. Noi comparam ofertele pentru tine si iti oferim cea mai buna solutie! </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <button className="btn effect py-3 px-5" onClick={() => navigateToSection('request', navigate, location)} data-aos="fade-left" data-aos-offset="-80" data-aos-delay="1100">
                            <span className="ms-2">Solicit Oferta</span>
                            <IconArrowBigRightLines className="ms-2" stroke={2} size={25}/>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;